import debug from "debug";

// Export top-level namespace for debug logging so
// that we can clearly separate the logs from other
// thirdparty library debugs.
export const appDebug = debug("app");

export const getInitialPropsDebug = appDebug.extend("getInitialProps");
export const storeDebug = appDebug.extend("store-logger");
